var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"updatelog-container"},[_c('section',[_c('simple-table',{attrs:{"index":!0,"isCheckbox":!1,"data":_vm.tableData,"columns":_vm.columns},on:{"query":_vm.initData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }